module.exports = __webpack_public_path__ + "media/images/icon_list/italic-25852d03e077fc36f5b7b9696abaf08b.svg";